var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm.send_store
            ? _c("div", { staticClass: "card-body" }, [
                _c(
                  "form",
                  {
                    attrs: { action: "" },
                    on: { submit: _vm.requestCalculation },
                  },
                  [
                    _c("div", { staticClass: "flex" }, [
                      _c("div", [
                        _c("label", [_vm._v("Склад отправитель")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.send_store,
                                expression: "send_store",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "send_store" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.send_store = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.send_store_list, function (store, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: store.id } },
                              [
                                _vm._v(
                                  _vm._s(store.name) + "\n                  "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [_vm._v("Склад получатель")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.receive_store,
                                expression: "receive_store",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "receive_store" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.receive_store = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(
                            _vm.receive_store_list,
                            function (store, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: store.id } },
                                [
                                  _vm._v(
                                    _vm._s(store.name) + "\n                  "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "relative",
                            "min-width": "200px",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              staticStyle: {
                                position: "absolute",
                                bottom: "0",
                              },
                              attrs: { type: "submit" },
                            },
                            [_vm._v("Создать автосписок\n                ")]
                          ),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "check_1" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.default_formula,
                                  expression: "default_formula",
                                },
                              ],
                              staticClass: "from-control",
                              attrs: {
                                type: "checkbox",
                                name: "",
                                id: "check_1",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.default_formula)
                                  ? _vm._i(_vm.default_formula, null) > -1
                                  : _vm.default_formula,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.default_formula,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.default_formula = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.default_formula = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.default_formula = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                  Использовать 60/17\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("pulse-loader", {
          staticStyle: { "text-align": "center" },
          attrs: { loading: _vm.loading, color: _vm.color },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.request
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.total_figures
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.total_figures[prep.id].request)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.total_figures[prep.id].store)
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", [_vm._v("Брони")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.requested_preps
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.requested_preps[prep.id])
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.preps_in_send_store[prep.id])
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("Закрываем бронь")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.closing_request.close
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.closing_request.close[prep.id])
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("НЕ закрываем бронь")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.closing_request.no
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.closing_request.no[prep.id])
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", [_vm._v("Запас")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.requested_store_preps
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.request.requested_store_preps[prep.id])
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.request.preps_in_receive_store[prep.id]
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.request.store_preps_for_supply[prep.id]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("Закрываем запас")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.store_closing_request.close
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.request.store_closing_request.close[prep.id]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("НЕ закрываем запас")]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-hover" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      _vm.orderedPrepNames(
                        _vm.request.prep_names,
                        _vm.request.store_closing_request.no
                      ),
                      function (prep, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(prep.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.request.store_closing_request.no[prep.id]
                              )
                            ),
                          ]),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Закрываем бронь")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Закрываем Запас")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Для закрытия брони")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("На отправителе")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Запрос на запас")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("На получателе")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("На Отправителе")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { staticClass: "wd-40" }),
      _vm._v(" "),
      _c("th", { staticClass: "wd-200" }),
      _vm._v(" "),
      _c("th", [_vm._v("Препарат")]),
      _vm._v(" "),
      _c("th", { staticClass: "wd-100" }, [_vm._v("Количество")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }